import React, { useState, useCallback, useRef, useEffect, useMemo } from "react";
import { Link } from "react-router-dom";

// Ensure these point to your actual component paths
import Sidebar from "../Includes/Sidebar";
import TopBar from "../Includes/TopBar";
import BottomNav from "../Includes/BottomNav";
// US_CITIES is now defined inline below
// ── COLOR THEME ──────────────────────────────────────────────────────
const T = {
  bg:"#f3f4f6", surface:"#ffffff", line:"#e5e7eb", line2:"#f9fafb",
  teal:"#0099a8", tealLight:"#e6f7f9", tealDark:"#007a87",
  amber:"#e07b00", amberLight:"#fef3e2",
  slate:"#64748b", muted:"#9ca3af", mutedBg:"#f3f4f6",
  text:"#111827", white:"#ffffff",
  green:"#16a34a", greenLight:"#f0fdf4",
  red:"#ef4444",
};




// ── MAJOR US CITIES FOR OVERSIZE LOADS ──────────────────────────────
// Edit this list to add/remove cities
const US_CITIES = [
  // Texas
  "Houston, TX","Dallas, TX","Austin, TX","San Antonio, TX","Fort Worth, TX",
  "El Paso, TX","Corpus Christi, TX","Lubbock, TX","Amarillo, TX","Beaumont, TX",
  "Midland, TX","Odessa, TX","Abilene, TX","Wichita Falls, TX","Laredo, TX",
  "Waco, TX","Tyler, TX","McAllen, TX","Brownsville, TX","Longview, TX",
  // Florida
  "Miami, FL","Orlando, FL","Tampa, FL","Jacksonville, FL","Fort Lauderdale, FL",
  "St. Petersburg, FL","Tallahassee, FL","Cape Coral, FL","Sarasota, FL","Gainesville, FL",
  "Pensacola, FL","Naples, FL","Lakeland, FL","Ocala, FL","Daytona Beach, FL",
  // California
  "Los Angeles, CA","San Francisco, CA","San Diego, CA","Sacramento, CA","Fresno, CA",
  "Long Beach, CA","Oakland, CA","Bakersfield, CA","San Jose, CA","Riverside, CA",
  "Stockton, CA","Chula Vista, CA","Irvine, CA","Modesto, CA","Oxnard, CA",
  // New York
  "New York, NY","Buffalo, NY","Albany, NY","Syracuse, NY","Rochester, NY",
  "Yonkers, NY","New Rochelle, NY","Binghamton, NY","Utica, NY",
  // Georgia
  "Atlanta, GA","Augusta, GA","Savannah, GA","Macon, GA","Columbus, GA",
  "Athens, GA","Valdosta, GA","Albany, GA","Warner Robins, GA",
  // Colorado
  "Denver, CO","Colorado Springs, CO","Aurora, CO","Fort Collins, CO","Lakewood, CO",
  "Thornton, CO","Pueblo, CO","Loveland, CO","Grand Junction, CO",
  // Washington
  "Seattle, WA","Spokane, WA","Tacoma, WA","Vancouver, WA","Bellevue, WA",
  "Kent, WA","Everett, WA","Yakima, WA","Olympia, WA","Bellingham, WA",
  // Oregon
  "Portland, OR","Eugene, OR","Salem, OR","Gresham, OR","Hillsboro, OR",
  "Bend, OR","Medford, OR","Springfield, OR",
  // North Carolina
  "Charlotte, NC","Raleigh, NC","Greensboro, NC","Durham, NC","Winston-Salem, NC",
  "Fayetteville, NC","Wilmington, NC","Asheville, NC",
  // Arizona
  "Phoenix, AZ","Tucson, AZ","Mesa, AZ","Scottsdale, AZ","Tempe, AZ",
  "Chandler, AZ","Glendale, AZ","Flagstaff, AZ","Yuma, AZ",
  // Nevada
  "Las Vegas, NV","Henderson, NV","Reno, NV","North Las Vegas, NV","Sparks, NV",
  // Illinois
  "Chicago, IL","Aurora, IL","Rockford, IL","Joliet, IL","Naperville, IL",
  "Springfield, IL","Peoria, IL","Elgin, IL",
  // Ohio
  "Columbus, OH","Cleveland, OH","Cincinnati, OH","Toledo, OH","Akron, OH",
  "Dayton, OH","Parma, OH","Canton, OH","Youngstown, OH",
  // Michigan
  "Detroit, MI","Grand Rapids, MI","Warren, MI","Sterling Heights, MI","Lansing, MI",
  "Ann Arbor, MI","Flint, MI","Dearborn, MI","Livonia, MI",
  // Pennsylvania
  "Philadelphia, PA","Pittsburgh, PA","Allentown, PA","Erie, PA","Reading, PA",
  "Scranton, PA","Bethlehem, PA","Lancaster, PA","Harrisburg, PA",
  // New Jersey
  "Newark, NJ","Jersey City, NJ","Trenton, NJ","Paterson, NJ","Elizabeth, NJ",
  // Virginia
  "Virginia Beach, VA","Norfolk, VA","Richmond, VA","Chesapeake, VA","Arlington, VA",
  "Newport News, VA","Roanoke, VA","Hampton, VA",
  // Tennessee
  "Memphis, TN","Nashville, TN","Knoxville, TN","Chattanooga, TN","Clarksville, TN",
  // Indiana
  "Indianapolis, IN","Fort Wayne, IN","Evansville, IN","South Bend, IN","Carmel, IN",
  // Missouri
  "Kansas City, MO","St. Louis, MO","Springfield, MO","Columbia, MO","Independence, MO",
  // Minnesota
  "Minneapolis, MN","St. Paul, MN","Rochester, MN","Duluth, MN","Bloomington, MN",
  // Wisconsin
  "Milwaukee, WI","Madison, WI","Green Bay, WI","Kenosha, WI","Racine, WI",
  // Massachusetts
  "Boston, MA","Worcester, MA","Springfield, MA","Lowell, MA","Cambridge, MA",
  // Maryland
  "Baltimore, MD","Columbia, MD","Germantown, MD","Silver Spring, MD","Frederick, MD",
  // Oklahoma
  "Oklahoma City, OK","Tulsa, OK","Norman, OK","Broken Arrow, OK","Lawton, OK",
  // Louisiana
  "New Orleans, LA","Baton Rouge, LA","Shreveport, LA","Metairie, LA","Lafayette, LA",
  // Kentucky
  "Louisville, KY","Lexington, KY","Bowling Green, KY","Owensboro, KY",
  // Alabama
  "Birmingham, AL","Montgomery, AL","Huntsville, AL","Mobile, AL","Tuscaloosa, AL",
  // South Carolina
  "Charleston, SC","Columbia, SC","North Charleston, SC","Mount Pleasant, SC","Greenville, SC",
  // Utah
  "Salt Lake City, UT","West Valley City, UT","Provo, UT","West Jordan, UT","Orem, UT","Ogden, UT",
  // Kansas
  "Wichita, KS","Overland Park, KS","Kansas City, KS","Topeka, KS","Olathe, KS",
  // New Mexico
  "Albuquerque, NM","Las Cruces, NM","Rio Rancho, NM","Santa Fe, NM","Roswell, NM",
  // Iowa
  "Des Moines, IA","Cedar Rapids, IA","Davenport, IA","Sioux City, IA",
  // Arkansas
  "Little Rock, AR","Fort Smith, AR","Fayetteville, AR","Springdale, AR","Jonesboro, AR",
  // Mississippi
  "Jackson, MS","Gulfport, MS","Southaven, MS","Hattiesburg, MS","Biloxi, MS",
  // Nebraska
  "Omaha, NE","Lincoln, NE","Bellevue, NE","Grand Island, NE",
  // Idaho
  "Boise, ID","Nampa, ID","Meridian, ID","Idaho Falls, ID","Pocatello, ID",
  // West Virginia
  "Charleston, WV","Huntington, WV","Morgantown, WV","Parkersburg, WV",
  // Hawaii / Alaska
  "Honolulu, HI","Anchorage, AK","Fairbanks, AK","Juneau, AK",
  // Montana
  "Billings, MT","Missoula, MT","Great Falls, MT","Bozeman, MT","Helena, MT",
  // North/South Dakota
  "Fargo, ND","Bismarck, ND","Grand Forks, ND","Sioux Falls, SD","Rapid City, SD",
  // Wyoming
  "Cheyenne, WY","Casper, WY","Laramie, WY","Gillette, WY",
  // Connecticut
  "Bridgeport, CT","New Haven, CT","Hartford, CT","Stamford, CT","Waterbury, CT",
  // Delaware/Rhode Island/Vermont/Maine/NH
  "Wilmington, DE","Providence, RI","Burlington, VT","Portland, ME","Manchester, NH",
];

// ── SEARCHABLE CITY DROPDOWN ─────────────────────────────────────────────────
// Replaces the broken react-select/plain-select hybrid.
// Fully keyboard accessible, filterable, no external dependencies.
function CitySearchDropdown({ value, onChange, placeholder, excludeCity }) {
  const [open,    setOpen]    = React.useState(false);
  const [query,   setQuery]   = React.useState("");
  const inputRef  = React.useRef(null);
  const listRef   = React.useRef(null);
  const wrapRef   = React.useRef(null);

  // Close when clicking outside
  useEffect(() => {
    const close = (e) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", close);
    return () => document.removeEventListener("mousedown", close);
  }, []);

  // Auto-scroll highlighted item into view
  const filtered = React.useMemo(() => {
    const q = query.trim().toLowerCase();
    const list = excludeCity ? US_CITIES.filter(c => c !== excludeCity) : US_CITIES;
    if (!q) return list;
    const exact   = list.filter(c => c.toLowerCase().startsWith(q));
    const contain = list.filter(c => !c.toLowerCase().startsWith(q) && c.toLowerCase().includes(q));
    return [...exact, ...contain];
  }, [query, excludeCity]);

  const handleOpen = () => {
    setOpen(true);
    setQuery("");
    setTimeout(() => inputRef.current?.focus(), 50);
  };

  const handleSelect = (city) => {
    onChange(city);
    setOpen(false);
    setQuery("");
  };

  const handleClear = (e) => {
    e.stopPropagation();
    onChange("");
    setQuery("");
  };

  const handleKeyDown = (e) => {
    if (e.key === "Escape") { setOpen(false); setQuery(""); }
  };

  // State code extracted for the flag badge
  const stateCode = value ? value.split(", ").pop() : null;

  return (
    <div ref={wrapRef} style={{ position: "relative" }}>
      {/* ── Trigger button ── */}
      <div
        onClick={handleOpen}
        style={{
          display: "flex", alignItems: "center", gap: 8,
          width: "100%", background: T.white,
          border: `1.5px solid ${open ? T.teal : T.line}`,
          borderRadius: 10, padding: "10px 12px",
          cursor: "pointer", userSelect: "none",
          transition: "border-color 0.2s", minHeight: 46,
        }}
      >
        {value ? (
          <>
            {stateCode && (
              <span style={{
                background: T.tealLight, color: T.teal,
                fontSize: 10, fontWeight: 800, padding: "2px 7px",
                borderRadius: 6, flexShrink: 0, letterSpacing: "0.5px",
              }}>
                {stateCode}
              </span>
            )}
            <span style={{ flex: 1, color: T.text, fontSize: 14, fontWeight: 600, minWidth: 0, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
              {value.split(", ")[0]}
            </span>
            <button
              onClick={handleClear}
              style={{ flexShrink: 0, color: T.muted, fontSize: 16, lineHeight: 1, background: "none", border: "none", cursor: "pointer", padding: "0 2px" }}
              tabIndex={-1}
            >×</button>
          </>
        ) : (
          <>
            <span style={{ color: T.muted, fontSize: 14, flex: 1 }}>{placeholder}</span>
          </>
        )}
        <span style={{ color: T.muted, fontSize: 12, flexShrink: 0, opacity: 0.6 }}>▾</span>
      </div>

      {/* ── Dropdown panel ── */}
      {open && (
        <div style={{
          position: "absolute", top: "calc(100% + 4px)", left: 0, right: 0,
          background: T.white, border: `1.5px solid ${T.teal}`,
          borderRadius: 12, boxShadow: "0 8px 32px rgba(0,0,0,0.13)",
          zIndex: 9999, overflow: "hidden",
        }}>
          {/* Search input */}
          <div style={{ padding: "10px 12px", borderBottom: `1px solid ${T.line}`, background: T.tealLight }}>
            <div style={{ position: "relative" }}>
              <span style={{ position: "absolute", left: 10, top: "50%", transform: "translateY(-50%)", fontSize: 14, color: T.teal }}>🔍</span>
              <input
                ref={inputRef}
                value={query}
                onChange={e => setQuery(e.target.value)}
                onKeyDown={handleKeyDown}
                placeholder="Type city or state code..."
                style={{
                  width: "100%", border: `1.5px solid ${T.teal}`, borderRadius: 8,
                  padding: "8px 8px 8px 32px", fontSize: 13, color: T.text,
                  outline: "none", background: T.white, fontFamily: "inherit",
                  boxSizing: "border-box",
                }}
              />
            </div>
            {filtered.length > 0 && (
              <div style={{ color: T.muted, fontSize: 11, marginTop: 5, fontWeight: 500 }}>
                {filtered.length === US_CITIES.length
                  ? `${US_CITIES.length} cities — type to filter`
                  : `${filtered.length} match${filtered.length !== 1 ? "es" : ""}`}
              </div>
            )}
          </div>

          {/* City list */}
          <div ref={listRef} style={{ maxHeight: 240, overflowY: "auto" }}>
            {filtered.length === 0 ? (
              <div style={{ padding: "18px 16px", color: T.muted, fontSize: 13, textAlign: "center" }}>
                No cities found for "{query}"
              </div>
            ) : (
              filtered.map((city) => {
                const sc = city.split(", ").pop();
                const cn = city.split(", ")[0];
                const isSelected = city === value;
                return (
                  <div
                    key={city}
                    onClick={() => handleSelect(city)}
                    style={{
                      display: "flex", alignItems: "center", gap: 10,
                      padding: "9px 14px", cursor: "pointer",
                      background: isSelected ? T.tealLight : "transparent",
                      borderLeft: isSelected ? `3px solid ${T.teal}` : "3px solid transparent",
                      transition: "background 0.1s",
                    }}
                    onMouseEnter={e => { if (!isSelected) e.currentTarget.style.background = T.line2; }}
                    onMouseLeave={e => { if (!isSelected) e.currentTarget.style.background = "transparent"; }}
                  >
                    <span style={{
                      background: isSelected ? T.teal : T.line2,
                      color: isSelected ? T.white : T.slate,
                      fontSize: 9, fontWeight: 800, padding: "2px 6px",
                      borderRadius: 5, minWidth: 28, textAlign: "center",
                      letterSpacing: "0.5px", flexShrink: 0,
                    }}>
                      {sc}
                    </span>
                    <span style={{
                      color: isSelected ? T.teal : T.text,
                      fontSize: 13, fontWeight: isSelected ? 700 : 500,
                      flex: 1,
                    }}>
                      {cn}
                    </span>
                    {isSelected && <span style={{ color: T.teal, fontSize: 14 }}>✓</span>}
                  </div>
                );
              })
            )}
          </div>
        </div>
      )}
    </div>
  );
}


const LOAD_TYPES = [
  "Wind Turbine Blade","Industrial Generator","Bridge Beam","Mobile Home",
  "Drilling Rig Component","Oversized Excavator","Transformer","Prefab Structure",
  "Large HVAC Unit","Crane Component","Oil Rig Equipment","Custom/Other",
];

const PAY_PRESETS = ["$500 - $1,000", "$1,000 - $2,500", "$2,500 - $5,000", "Custom Amount"];
const PAY_TYPES = ["Fixed Rate", "Negotiable", "Per Mile", "Hourly"];

const WIDTH_OPTIONS = [
  "8' 0\"", "8' 6\"", "9' 0\"", "10' 0\"", "11' 0\"",
  "12' 0\"", "12' 6\"", "13' 0\"", "14' 0\"", "14' 6\"",
  "15' 0\"", "16' 0\"", "17' 0\"", "18' 0\"", "20' 0\"", "Custom",
];

const HEIGHT_OPTIONS = [
  "13' 0\"", "13' 6\"", "14' 0\"", "14' 6\"", "15' 0\"",
  "15' 6\"", "16' 0\"", "16' 6\"", "17' 0\"", "18' 0\"", "Custom",
];

const CITY_COORDS = {
  "Houston, TX":     [29.7604, -95.3698], "Dallas, TX":      [32.7767, -96.7970],
  "Austin, TX":      [30.2672, -97.7431], "San Antonio, TX": [29.4241, -98.4936],
  "Seattle, WA":     [47.6062, -122.3321],"Portland, OR":    [45.5051, -122.6750],
  "Denver, CO":      [39.7392, -104.9903],"Atlanta, GA":     [33.7490, -84.3880],
  // ... Keep all your coordinates here
};

// ── REUSABLE UI COMPONENTS ───────────────────────────────────────────
function RouteMap({ origin, destination }) {
  const fromCoords = CITY_COORDS[origin] || [39.8283, -98.5795];
  const toCoords   = CITY_COORDS[destination] || [39.8283, -98.5795];

  const midLat  = (fromCoords[0] + toCoords[0]) / 2;
  const midLng  = (fromCoords[1] + toCoords[1]) / 2;
  const dLat    = toCoords[0] - fromCoords[0];
  const dLng    = toCoords[1] - fromCoords[1];
  const distMi  = Math.round(Math.sqrt(dLat*dLat + dLng*dLng) * 69);
  const zoom = distMi < 80 ? 8 : distMi < 200 ? 7 : distMi < 400 ? 6 : 5;

  const mapHtml = `<!DOCTYPE html>
<html><head>
<meta charset="utf-8"/>
<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/leaflet.min.css"/>
<script src="https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/leaflet.min.js"></script>
<style>*{margin:0;padding:0;box-sizing:border-box;}html,body,#map{width:100%;height:100%;}</style>
</head><body>
<div id="map"></div>
<script>
var map = L.map('map', {zoomControl:true, attributionControl:false}).setView([${midLat},${midLng}],${zoom});
L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',{maxZoom:18}).addTo(map);

var fromPt = [${fromCoords[0]},${fromCoords[1]}];
var toPt   = [${toCoords[0]},${toCoords[1]}];
var dLat = toPt[0] - fromPt[0];
var dLng = toPt[1] - fromPt[1];
var pts = [];
var steps = 20;
for(var i=0;i<=steps;i++){
  var t = i/steps;
  var cx = (fromPt[1]+toPt[1])/2 + dLat*0.15;
  var cy = (fromPt[0]+toPt[0])/2 - dLng*0.15;
  var lat = (1-t)*(1-t)*fromPt[0] + 2*(1-t)*t*cy + t*t*toPt[0];
  var lng = (1-t)*(1-t)*fromPt[1] + 2*(1-t)*t*cx + t*t*toPt[1];
  pts.push([lat,lng]);
}

L.polyline(pts,{color:'#0099a8',weight:4,opacity:0.85,dashArray:null}).addTo(map);
L.polyline(pts,{color:'#005f6b',weight:6,opacity:0.2}).addTo(map);

var originIcon = L.divIcon({html:'<div style="background:#e07b00;width:14px;height:14px;border-radius:50%;border:3px solid white;box-shadow:0 2px 6px rgba(0,0,0,0.35);"></div>',iconAnchor:[7,7],className:''});
var destIcon   = L.divIcon({html:'<div style="background:#0099a8;width:18px;height:18px;border-radius:50%;border:3px solid white;box-shadow:0 2px 8px rgba(0,0,0,0.4);"></div>',iconAnchor:[9,9],className:''});

L.marker(fromPt,{icon:originIcon}).addTo(map).bindTooltip('<b style="font-family:sans-serif;font-size:12px">${origin.replace(/'/g,"\\'")}</b>',{permanent:false,direction:'top'});
L.marker(toPt,  {icon:destIcon  }).addTo(map).bindTooltip('<b style="font-family:sans-serif;font-size:12px">${destination.replace(/'/g,"\\'")}</b>',{permanent:false,direction:'top'});
</script>
</body></html>`;

  return (
    <div style={{ marginTop:16, borderRadius:12, overflow:"hidden", border:`1px solid ${T.line}`, boxShadow:"0 2px 8px #0000000f" }}>
      <div style={{ background:T.tealLight, padding:"10px 16px", display:"flex", alignItems:"center", justifyContent:"space-between", borderBottom:`1px solid ${T.teal}20` }}>
        <div style={{ display:"flex", alignItems:"center", gap:8 }}>
          <span className="truncate max-w-[100px] sm:max-w-none" style={{ color:T.amber, fontWeight:800, fontSize:13 }}>📍 {origin}</span>
          <span style={{ color:T.muted, fontSize:14 }}>→</span>
          <span className="truncate max-w-[100px] sm:max-w-none" style={{ color:T.teal, fontWeight:800, fontSize:13 }}>🏁 {destination}</span>
        </div>
        <span style={{ color:T.teal, fontSize:12, fontWeight:700, flexShrink:0 }}>~{distMi} mi</span>
      </div>
      <iframe srcDoc={mapHtml} style={{ width:"100%", height:260, border:"none", display:"block" }} title="Route Map" />
    </div>
  );
}

function Label({ children, required }) {
  return (
    <div style={{ color:T.slate, fontSize:12, fontWeight:600, letterSpacing:"1px", textTransform:"uppercase", marginBottom:6 }}>
      {children}{required && <span style={{ color:T.red, marginLeft:3 }}>*</span>}
    </div>
  );
}

function Field({ children, style, className }) {
  return <div className={className} style={{ marginBottom:16, ...style }}>{children}</div>;
}

function Input({ value, onChange, placeholder, type="text", prefix, suffix }) {
  return (
    <div style={{ position:"relative" }}>
      {prefix && <span style={{ position:"absolute", left:12, top:"50%", transform:"translateY(-50%)", color:T.muted, fontSize:14 }}>{prefix}</span>}
      <input type={type} value={value} onChange={e=>onChange(e.target.value)}
        placeholder={placeholder}
        style={{ width:"100%", background:T.white, border:`1.5px solid ${T.line}`,
          borderRadius:10, padding:prefix?"12px 12px 12px 32px":suffix?"12px 52px 12px 12px":"12px",
          color:T.text, fontSize:14, outline:"none", boxSizing:"border-box", fontFamily:"inherit", transition:"border-color 0.2s" }}
        onFocus={e=>e.target.style.borderColor=T.teal}
        onBlur={e=>e.target.style.borderColor=T.line}/>
      {suffix && <span style={{ position:"absolute", right:12, top:"50%", transform:"translateY(-50%)", color:T.muted, fontSize:13 }}>{suffix}</span>}
    </div>
  );
}

function Select({ value, onChange, options, placeholder }) {
  return (
    <div style={{ position:"relative" }}>
      <select value={value} onChange={e=>onChange(e.target.value)}
        style={{ width:"100%", background:T.white, border:`1.5px solid ${T.line}`,
          borderRadius:10, padding:"12px 36px 12px 12px", color:value?T.text:T.muted,
          fontSize:14, outline:"none", cursor:"pointer", fontFamily:"inherit", appearance:"none",
          backgroundImage:`url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%2394a3b8' stroke-width='2'%3E%3Cpolyline points='6,9 12,15 18,9'/%3E%3C/svg%3E")`,
          backgroundRepeat:"no-repeat", backgroundPosition:"right 12px center", transition:"border-color 0.2s" }}
        onFocus={e=>e.target.style.borderColor=T.teal}
        onBlur={e=>e.target.style.borderColor=T.line}>
        <option value="">{placeholder}</option>
        {options.map(o=><option key={o} value={o}>{o}</option>)}
      </select>
    </div>
  );
}

function Checkbox({ label, checked, onChange, sub }) {
  return (
    <div onClick={()=>onChange(!checked)}
      style={{ display:"flex", alignItems:"flex-start", gap:12, padding:"13px 16px",
        borderRadius:11, border:`1.5px solid ${checked?T.teal:T.line}`,
        background:checked?T.tealLight:T.white, cursor:"pointer", transition:"all 0.15s" }}>
      <div style={{ width:20, height:20, borderRadius:5, flexShrink:0, marginTop: 2,
        border:`2px solid ${checked?T.teal:T.muted}`, background:checked?T.teal:"transparent",
        display:"flex", alignItems:"center", justifyContent:"center" }}>
        {checked && <span style={{ color:T.white, fontSize:13, fontWeight:800 }}>✓</span>}
      </div>
      <div className="min-w-0">
        <div style={{ color:checked?T.teal:T.text, fontWeight:600, fontSize:14 }} className="truncate">{label}</div>
        {sub && <div style={{ color:T.muted, fontSize:11, marginTop:1, lineHeight:1.3 }}>{sub}</div>}
      </div>
    </div>
  );
}

function SectionCard({ icon, title, children }) {
  return (
    <div className="bg-white rounded-2xl p-4 sm:p-6 mb-4 sm:mb-5 shadow-sm" style={{ border:`1px solid ${T.line}` }}>
      <div className="flex items-center gap-2.5 mb-4 sm:mb-5">
        <span className="text-[20px]" style={{ color:T.teal }}>{icon}</span>
        <span className="font-extrabold text-[16px] sm:text-[17px]" style={{ color:T.text }}>{title}</span>
      </div>
      {children}
    </div>
  );
}

// ── RIGHT SIDEBAR PREVIEW ────────────────────────────────────────────
function LoadPreview({ form, featured }) {
  const hasRoute = form.origin && form.destination;
  const typeColor = {
    "Wind Turbine Blade":T.teal,"Bridge Beam":"#ea580c","Mobile Home":T.green,
    "Industrial Generator":"#7c3aed","Drilling Rig Component":T.amber,
  }[form.loadType] || T.slate;

  return (
    <div className="bg-white rounded-[14px] p-4 sm:p-5 shadow-sm" style={{ border:`2px solid ${T.teal}` }}>
      <div style={{ color:T.teal, fontSize:10, fontWeight:700, letterSpacing:"2px", textTransform:"uppercase", marginBottom:10 }}>LOAD BOARD PREVIEW</div>
      {!hasRoute ? (
        <div style={{ textAlign:"center", padding:"24px 0", color:T.muted, fontSize:13 }}>Fill in route details to preview your listing</div>
      ) : (
        <>
          <div className="flex justify-between items-start mb-3 gap-3">
            <div className="flex-1 min-w-0">
              <div className="flex gap-1.5 flex-wrap mb-2">
                {featured && <span style={{ background:`${T.amber}18`, color:T.amber, fontSize:10, fontWeight:700, padding:"2px 8px", borderRadius:99, border:`1px solid ${T.amber}30`, whiteSpace:"nowrap" }}>⚡ Featured</span>}
                <span style={{ background:T.tealLight, color:T.teal, fontSize:10, fontWeight:700, padding:"2px 8px", borderRadius:99, border:`1px solid ${T.teal}30`, whiteSpace:"nowrap" }}>✓ PPCA</span>
              </div>
              <div className="font-extrabold text-[14px] sm:text-[15px] text-gray-900 mb-1 leading-snug break-words">
                {form.origin}{form.originZip && <span style={{ fontSize:11, fontWeight:600, color:T.muted }}> {form.originZip}</span>}
                {" "}<br className="sm:hidden" /><span className="hidden sm:inline">→</span><span className="sm:hidden">↓</span>{" "}
                {form.destination}{form.destinationZip && <span style={{ fontSize:11, fontWeight:600, color:T.muted }}> {form.destinationZip}</span>}
              </div>
              <div style={{ color:T.slate, fontSize:12 }}>{form.date || "TBD"} · Pickup</div>
            </div>
            <div className="rounded-[10px] p-2 sm:px-3 sm:py-2 text-center flex-shrink-0" style={{ background:T.greenLight, border:`1px solid ${T.green}30` }}>
              <div style={{ color:T.muted, fontSize:9, fontWeight:600, textTransform:"uppercase", letterSpacing:"1px" }}>Est. Pay</div>
              <div style={{ color:T.green, fontWeight:800, fontSize:16 }} className="sm:text-[18px]">
                {form.pay === "Custom Amount" && form.customPay
                  ? `$${Number(form.customPay).toLocaleString()}`
                  : form.pay && form.pay !== "Custom Amount"
                  ? form.pay
                  : "TBD"}
              </div>
            </div>
          </div>
          {form.loadType && (
            <div className="inline-flex items-center gap-1.5 px-2.5 py-1.5 rounded-lg mb-3" style={{ background:`${typeColor}12`, border:`1px solid ${typeColor}25` }}>
              <div className="w-1.5 h-1.5 rounded-full flex-shrink-0" style={{ background:typeColor }}/>
              <span className="text-[11px] font-bold" style={{ color:typeColor }}>{form.loadType}</span>
            </div>
          )}
          
          {/* Responsive Grid for Details */}
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-2 mb-2">
            {[
              { label:"Width", value:form.width||"—" },
              { label:"Height", value:form.height||"—" },
              { label:"Weight", value:form.weight?`${form.weight} lbs`:"—" },
              { label:"Escorts", value:[form.frontEscort, form.chaseEscort, form.heightPole, form.steersman].filter(Boolean).length||"—" },
            ].map(s=>(
              <div key={s.label} className="rounded-lg p-2 text-center" style={{ background:T.line2 }}>
                <div style={{ color:T.muted, fontSize:9, fontWeight:600, textTransform:"uppercase", letterSpacing:"0.5px" }}>{s.label}</div>
                <div className="font-bold text-[11px] mt-1" style={{ color:T.text }}>{s.value}</div>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
}

// ── SUCCESS SCREEN ───────────────────────────────────────────────────
function SuccessScreen({ form, onReset }) {
  return (
    <div className="flex-1 flex items-center justify-center p-5 font-sans" style={{ background: T.bg }}>
      <div style={{ maxWidth:480, width:"100%", textAlign:"center" }}>
        <div style={{ fontSize:60, marginBottom:16 }}>🚛</div>
        <div style={{ fontFamily:"'Plus Jakarta Sans',sans-serif", fontSize:26, fontWeight:800, color:T.green, marginBottom:8 }}>Load Posted!</div>
        <div style={{ color:T.slate, fontSize:14, lineHeight:1.7, marginBottom:24 }}>
          Your load is now live on the PilotLink load board. Certified drivers in your area will be notified immediately.
        </div>
        <div className="flex flex-col sm:flex-row gap-3">
          <button onClick={onReset} className="flex-1" style={{ padding:"13px", borderRadius:12, border:`1.5px solid ${T.line}`, background:T.white, color:T.slate, fontWeight:700, fontSize:14, cursor:"pointer" }}>
            Post Another Load
          </button>
          <Link to="/my-loads" className="flex-1" style={{ padding:"13px", borderRadius:12, border:"none", background:T.teal, color:T.white, fontWeight:800, fontSize:14, cursor:"pointer", textDecoration:"none", display:"inline-block" }}>
            View Dashboard →
          </Link>
        </div>
      </div>
    </div>
  );
}


// ── ZIP CODE LOOKUP COMPONENT ────────────────────────────────────────────────
// Calls api.zippopotam.us (free, no key needed) when user types a full 5-digit ZIP.
// Shows a teal suggestion pill below the input; user clicks to auto-fill city+state.
// If lookup fails gracefully shows a red "not found" hint.
//
// Props:
//   value        {string}  current ZIP value (controlled)
//   onChange     {fn}      called with new ZIP string (digits only, max 5)
//   onCityFound  {fn}      called with { city, state, zip } when lookup succeeds
//   placeholder  {string}
//   linkedCity   {string}  the current city value — shown in the suggestion chip

function ZipLookupInput({ value, onChange, onCityFound, placeholder = "e.g. 77001", linkedCity }) {
  const [status,  setStatus]  = React.useState("idle"); // idle | loading | found | error
  const [result,  setResult]  = React.useState(null);   // { city, state, zip }
  const timerRef = React.useRef(null);

  // Trigger lookup when ZIP reaches exactly 5 digits
  React.useEffect(() => {
    clearTimeout(timerRef.current);
    if (value.length !== 5) {
      setStatus("idle");
      setResult(null);
      return;
    }
    setStatus("loading");
    timerRef.current = setTimeout(async () => {
      try {
        const res  = await fetch(`https://api.zippopotam.us/us/${value}`);
        if (!res.ok) throw new Error("not found");
        const data = await res.json();
        const place = data.places?.[0];
        if (!place) throw new Error("no places");
        const city  = place["place name"];
        const state = place["state abbreviation"];
        setResult({ city, state, zip: value });
        setStatus("found");
      } catch {
        setStatus("error");
        setResult(null);
      }
    }, 350); // debounce — wait 350ms after last keystroke
    return () => clearTimeout(timerRef.current);
  }, [value]);

  const handleInput = (v) => {
    const clean = v.replace(/\D/g, "").slice(0, 5);
    onChange(clean);
  };

  const handleApply = () => {
    if (result) {
      onCityFound(result);
      setStatus("idle"); // collapse the pill after applying
    }
  };

  // Border color reflects state
  const borderColor =
    status === "found"   ? T.green  :
    status === "error"   ? T.red    :
    status === "loading" ? T.teal   : T.line;

  return (
    <div style={{ position: "relative" }}>
      {/* ZIP input */}
      <div style={{ position: "relative" }}>
        <input
          type="text"
          inputMode="numeric"
          value={value}
          onChange={e => handleInput(e.target.value)}
          placeholder={placeholder}
          maxLength={5}
          style={{
            width: "100%", background: T.white,
            border: `1.5px solid ${borderColor}`,
            borderRadius: 10, padding: "12px 36px 12px 12px",
            color: T.text, fontSize: 14, outline: "none",
            boxSizing: "border-box", fontFamily: "inherit",
            transition: "border-color 0.2s",
            letterSpacing: value ? "2px" : "normal",
            fontWeight: value ? 700 : 400,
          }}
          onFocus={e  => e.target.style.borderColor = T.teal}
          onBlur={e   => e.target.style.borderColor = borderColor}
        />
        {/* Status icon inside field */}
        <span style={{
          position: "absolute", right: 10, top: "50%",
          transform: "translateY(-50%)", fontSize: 14, pointerEvents: "none",
        }}>
          {status === "loading" && <span style={{ color: T.teal }}>⟳</span>}
          {status === "found"   && <span style={{ color: T.green }}>✓</span>}
          {status === "error"   && <span style={{ color: T.red }}>✗</span>}
        </span>
      </div>

      {/* ── Result pill ── */}
      {status === "found" && result && (
        <div
          onClick={handleApply}
          style={{
            marginTop: 6, display: "flex", alignItems: "center", gap: 8,
            padding: "7px 10px", borderRadius: 8, cursor: "pointer",
            background: T.greenLight, border: `1.5px solid ${T.green}30`,
            transition: "background 0.15s",
          }}
          onMouseEnter={e => e.currentTarget.style.background = "#dcfce7"}
          onMouseLeave={e => e.currentTarget.style.background = T.greenLight}
        >
          <span style={{ fontSize: 12 }}>📍</span>
          <div style={{ flex: 1, minWidth: 0 }}>
            <span style={{ color: T.green, fontWeight: 800, fontSize: 12 }}>
              {result.city}, {result.state}
            </span>
            {linkedCity && linkedCity !== `${result.city}, ${result.state}` && (
              <span style={{ color: T.muted, fontSize: 11, marginLeft: 5 }}>
                ← tap to fill
              </span>
            )}
          </div>
          <span style={{
            background: T.green, color: T.white,
            fontSize: 9, fontWeight: 800, padding: "2px 7px",
            borderRadius: 5, flexShrink: 0, letterSpacing: "0.5px",
          }}>
            USE
          </span>
        </div>
      )}

      {/* ── Error hint ── */}
      {status === "error" && (
        <div style={{
          marginTop: 5, fontSize: 11, color: T.red,
          display: "flex", alignItems: "center", gap: 5,
        }}>
          <span>✗</span> ZIP not found — check the number or type city above
        </div>
      )}
    </div>
  );
}

// ── MAIN PAGE COMPONENT ──────────────────────────────────────────────
export default function PostLoadPage() {
  const [form, setForm] = useState({
    origin:"", originZip:"", destination:"", destinationZip:"", date:"", time:"",
    meetingPoint:"", meetingCity:"", meetingState:"", meetingZip:"", meetingTime:"",
    loadType:"", commodity:"",
    width:"", height:"", length:"48'", weight:"80,000",
    escortInitial:"", truckerInitial:"",
    frontEscort:false, chaseEscort:false, heightPole:false, steersman:false,
    overnight:false, pay:"", customPay:"", payType:"Fixed Rate",
    mileageRate:"", hourlyRate:"", minDailyPay:"",
    heightPolePay:"", escortAddons:"", fuelSurcharge:"Not Included",
    paymentMethod:"Zelle", paymentTerms:"NET 7",
    companyName:"", dispatcherName:"", dispatchPhone:"", dispatchEmail:"",
    notes:"",
  });
  
  const [featured, setFeatured] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  
  // Layout States matching your CompanyDashboard
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [notifCount, setNotifCount] = useState(2);
  const [activeNav, setActiveNav] = useState("loads"); 

  // Retrieving User Info & Token from LocalStorage
  const user = (() => { try { return JSON.parse(localStorage.getItem("user")); } catch { return null; } })();
  const token = localStorage.getItem("user_token"); 

  const companyName = user?.company_name || user?.name || "Company";
  const initials = companyName.split(" ").slice(0, 2).map(w => w[0]).join("").toUpperCase() || "CO";

  const upd = useCallback((k, v) => setForm(p => ({ ...p, [k]: v })), []);

  const total = featured ? 35 : 15;
  const canSubmit = form.origin && form.destination && form.date;

  // ── BACKEND API CALL ───────────────────────────────────────────────
  const handlePostLoad = async () => {
    if (!canSubmit) return;
    setIsSubmitting(true);
    
    try {
      const apiUrl = process.env.REACT_APP_API_URL || "http://127.0.0.1:8000";
      
      const headers = { 'Content-Type': 'application/json' };
      if (token) {
        headers['Authorization'] = `Bearer ${token}`;
      }

      const payload = {
        ...form,
        departure_date: form.date, // Map form.date to what Django expects
        departure_time: form.time, // Map form.time if Django expects departure_time
        needs_front_escort: form.frontEscort, // Map camelCase to snake_case
        needs_chase_escort: form.chaseEscort,
        needs_height_pole: form.heightPole,
        needs_steersman: form.steersman,
        featured: featured,
        company_email: form.dispatchEmail || user?.email || "",
        origin_zip:      form.originZip,
        destination_zip: form.destinationZip
      };
      
     const response = await fetch(`${apiUrl}/api/loads/create/`, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(payload)
      });
      
      const text = await response.text();
      
      if (text.trim().startsWith("<")) {
         throw new Error("Server returned an HTML page instead of JSON. Ensure your API URL and Token are correct.");
      }
      
      const data = JSON.parse(text);
      
      if (response.ok && data.success) {
        setSubmitted(true);
      } else {
        alert("Failed to post load: " + JSON.stringify(data.errors || data.message));
      }
    } catch (error) {
      console.error("Error posting load:", error);
      alert(error.message || "Network error occurred while trying to post the load.");
    } finally {
      setIsSubmitting(false);
    }
  };

  // ── RENDER RESPONSIVE WRAPPER ──────────────────────────────────────
  return (
    <div className="flex h-screen bg-gray-100 overflow-hidden" style={{ fontFamily: "Inter,system-ui,sans-serif", color:T.text }}>
      <style dangerouslySetInnerHTML={{__html: `
        @import url('https://fonts.googleapis.com/css2?family=Sora:wght@700;800&family=Inter:wght@400;500;600;700&display=swap');
        select option{background:#fff;color:#1e293b;}
        input::placeholder,textarea::placeholder{color:#9ca3af;}
      `}} />

      {/* Mobile Overlay */}
      {sidebarOpen && (
        <div className="fixed inset-0 bg-black/50 z-40 lg:hidden" onClick={() => setSidebarOpen(false)} />
      )}

      {/* Sidebar from Dashboard */}
      <Sidebar 
        activeNav={activeNav} setActiveNav={setActiveNav} 
        sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} 
        initials={initials} companyName={companyName} 
        loads={[]} activePostings={0} assignedLoads={0} totalSpent={0} 
      />

      {/* Main Content Area - Note: BottomNav has been moved INSIDE this div */}
      <div className="flex-1 flex flex-col overflow-hidden min-w-0 bg-[#f3f4f6]">
        
        <TopBar 
          title="Post a Load" 
          setSidebarOpen={setSidebarOpen} 
          initials={initials} 
          notifCount={notifCount} 
          setNotifCount={setNotifCount} 
        />

        <main className="flex-1 overflow-y-auto">
          {submitted ? (
            <SuccessScreen 
              form={form} 
              onReset={() => {
                setSubmitted(false);
                setForm(f => ({ ...f, destination:"", date:"", loadType:"", pay:"", customPay:"" }));
              }} 
            />
          ) : (
            <div className="max-w-6xl mx-auto px-4 sm:px-6 py-6 sm:py-8 pb-24 lg:pb-8">
              
              <div className="flex items-center gap-3 mb-6 sm:mb-8">
                <span className="text-2xl sm:text-3xl">🚛</span>
                <h1 style={{ fontFamily:"'Plus Jakarta Sans',sans-serif", fontWeight:800 }} className="text-[22px] sm:text-3xl text-gray-900">
                  Post an Oversize Load
                </h1>
              </div>

              {/* Responsive Layout Grid using Flexbox */}
              <div className="flex flex-col lg:flex-row gap-6 lg:gap-8 items-start w-full relative">
                
                {/* ── LEFT FORM ── */}
                <div className="flex-1 w-full min-w-0 space-y-4 sm:space-y-6">
                  {/* 1. Route Information */}
                  <SectionCard icon="📍" title="Route Information">
                    {/* Origin row: city dropdown + zip */}
                    <div className="flex flex-col sm:flex-row gap-3.5 mb-3.5">
                      <Field className="flex-1 mb-0">
                        <Label required>Origin (City, State)</Label>
                        <CitySearchDropdown value={form.origin} onChange={v=>upd("origin",v)} placeholder="Search city or state..." />
</Field>
                      <Field className="mb-0" style={{ width:"140px", flexShrink:0 }}>
                        <Label>Origin ZIP</Label>
                        <ZipLookupInput
                          value={form.originZip}
                          onChange={v => upd("originZip", v)}
                          linkedCity={form.origin}
                          placeholder="e.g. 77001"
                          onCityFound={({ city, state }) => {
                            upd("origin", `${city}, ${state}`);
                          }}
                        />
                      </Field>
                    </div>

                    {/* Destination row: city dropdown + zip */}
                    <div className="flex flex-col sm:flex-row gap-3.5 mb-3.5">
                      <Field className="flex-1 mb-0">
                        <Label required>Destination (City, State)</Label>
                        <CitySearchDropdown value={form.destination} onChange={v=>upd("destination",v)} placeholder="Search city or state..." excludeCity={form.origin}/>
                      </Field>
                      <Field className="mb-0" style={{ width:"140px", flexShrink:0 }}>
                        <Label>Destination ZIP</Label>
                        <ZipLookupInput
                          value={form.destinationZip}
                          onChange={v => upd("destinationZip", v)}
                          linkedCity={form.destination}
                          placeholder="e.g. 30301"
                          onCityFound={({ city, state }) => {
                            upd("destination", `${city}, ${state}`);
                          }}
                        />
                      </Field>
                    </div>

                    {/* Date + Time row */}
                    <div className="flex flex-col sm:flex-row gap-3.5 mb-3.5">
                      <Field className="flex-1 mb-0">
                        <Label required>Departure Date</Label>
                        <Input type="date" value={form.date} onChange={v=>upd("date",v)} placeholder=""/>
                      </Field>
                      <Field className="flex-1 mb-0">
                        <Label>Departure Time</Label>
                        <Input type="time" value={form.time} onChange={v=>upd("time",v)} placeholder=""/>
                      </Field>
                    </div>

                    {/* Meeting Point Details */}
                    <div className="rounded-xl p-3 sm:p-4 mt-4 sm:mt-5" style={{ background:T.line2, border:`1px solid ${T.line}` }}>
                      <div className="text-[10px] sm:text-[11px] font-bold uppercase tracking-wider mb-3" style={{ color:T.tealDark }}>📍 Meeting Point Setup</div>
                      <Field className="mb-3">
                        <Label>Street Address / Landmark</Label>
                        <Input value={form.meetingPoint} onChange={v=>upd("meetingPoint",v)} placeholder="e.g., Pilot Travel Center, Exit 42" />
                      </Field>
                      <div className="grid grid-cols-1 sm:grid-cols-4 gap-3 mb-3">
                        <Field className="sm:col-span-2 mb-0"><Label>City</Label><Input value={form.meetingCity} onChange={v=>upd("meetingCity",v)} placeholder="City" /></Field>
                        <Field className="mb-0"><Label>State</Label><Input value={form.meetingState} onChange={v=>upd("meetingState",v)} placeholder="TX" /></Field>
                        <Field className="mb-0">
                          <Label>ZIP Code</Label>
                          <ZipLookupInput
                            value={form.meetingZip}
                            onChange={v => upd("meetingZip", v)}
                            placeholder="79601"
                            onCityFound={({ city, state, zip }) => {
                              upd("meetingZip",   zip);
                              upd("meetingCity",  city);
                              upd("meetingState", state);
                            }}
                          />
                        </Field>
                      </div>
                      <Field className="mb-0 sm:w-1/2">
                        <Label>Meeting Time</Label>
                        <Input type="time" value={form.meetingTime} onChange={v=>upd("meetingTime",v)} placeholder=""/>
                      </Field>
                    </div>

                    {form.origin && form.destination && <RouteMap origin={form.origin} destination={form.destination}/>}
                  </SectionCard>

                  {/* 2. Dimensions */}
                  <SectionCard icon="📐" title="Load Dimensions & Specs">
                    <Field>
                      <Label>Commodity / Load Type</Label>
                      <Select value={form.loadType} onChange={v=>upd("loadType",v)} options={LOAD_TYPES} placeholder="Select load type"/>
                    </Field>
                    {form.loadType==="Custom/Other" && (
                      <Field>
                        <Label>Custom Description</Label>
                        <Input value={form.commodity} onChange={v=>upd("commodity",v)} placeholder="Describe your load"/>
                      </Field>
                    )}
                    <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4">
                      <div>
                        <Label>Width</Label>
                        <Select value={form.width} onChange={v=>upd("width",v)} options={WIDTH_OPTIONS} placeholder="Select..."/>
                      </div>
                      <div>
                        <Label>Height</Label>
                        <Select value={form.height} onChange={v=>upd("height",v)} options={HEIGHT_OPTIONS} placeholder="Select..."/>
                      </div>
                      <div>
                        <Label>Length</Label>
                        <Input value={form.length} onChange={v=>upd("length",v)} placeholder="110'" suffix="ft"/>
                      </div>
                      <div>
                        <Label>Weight</Label>
                        <Input value={form.weight} onChange={v=>upd("weight",v)} placeholder="80,000" suffix="lbs"/>
                      </div>
                    </div>
                    <div className="flex flex-col sm:flex-row gap-3 mt-4">
                      <Field className="flex-1 mb-0">
                        <Label>Escort Initial (Verify Dims)</Label>
                        <Input value={form.escortInitial} onChange={v=>upd("escortInitial",v)} placeholder="E.I."/>
                      </Field>
                      <Field className="flex-1 mb-0">
                        <Label>Trucker Initial (Verify Dims)</Label>
                        <Input value={form.truckerInitial} onChange={v=>upd("truckerInitial",v)} placeholder="T.I."/>
                      </Field>
                    </div>
                  </SectionCard>

                  {/* 3. Escorts */}
                  <SectionCard icon="🛡️" title="Required Escorts">
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                      <Checkbox label="Front Escort" sub="Lead vehicle ahead of load" checked={form.frontEscort} onChange={v=>upd("frontEscort",v)}/>
                      <Checkbox label="Chase Escort" sub="Follow vehicle behind load" checked={form.chaseEscort} onChange={v=>upd("chaseEscort",v)}/>
                      <Checkbox label="Height Pole" sub="Overhead clearance checks" checked={form.heightPole} onChange={v=>upd("heightPole",v)}/>
                      <Checkbox label="Steersman" sub="Rear steering operator" checked={form.steersman} onChange={v=>upd("steersman",v)}/>
                    </div>
                  </SectionCard>

                  {/* 4. Pay */}
                  <SectionCard icon="💰" title="Driver Pay & Rate Info">
                    <div className="flex flex-col sm:flex-row gap-3 mb-4">
                      <Field className="flex-1 mb-0">
                        <Label>Pay Preset</Label>
                        <Select value={form.pay} onChange={v=>upd("pay",v)} options={PAY_PRESETS} placeholder="Select a pay range..."/>
                      </Field>
                      <Field className="flex-1 mb-0">
                        <Label>Pay Type</Label>
                        <Select value={form.payType} onChange={v=>upd("payType",v)} options={PAY_TYPES} placeholder="Select pay type"/>
                      </Field>
                    </div>

                    {form.pay === "Custom Amount" && (
                      <Field className="mb-4">
                        <Label>Custom Total Amount (USD)</Label>
                        <Input value={form.customPay} onChange={v=>upd("customPay",v)} type="number" prefix="$" placeholder="Enter amount"/>
                      </Field>
                    )}

                    <div className="rounded-xl p-3 sm:p-4 mb-3 sm:mb-4" style={{ background:T.line2, border:`1px solid ${T.line}` }}>
                      <div className="text-[10px] font-bold uppercase tracking-widest mb-3" style={{ color:T.amber }}>📌 Base Rate Details</div>
                      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
                        <Field className="mb-0"><Label>Mileage ($/mi)</Label><Input value={form.mileageRate} onChange={v=>upd("mileageRate",v)} prefix="$" placeholder="1.95"/></Field>
                        <Field className="mb-0"><Label>Hourly ($/hr)</Label><Input value={form.hourlyRate} onChange={v=>upd("hourlyRate",v)} prefix="$" placeholder="55"/></Field>
                        <Field className="mb-0"><Label>Min Daily</Label><Input value={form.minDailyPay} onChange={v=>upd("minDailyPay",v)} prefix="$" placeholder="N/A"/></Field>
                      </div>
                    </div>

                    <div className="rounded-xl p-3 sm:p-4 mb-3 sm:mb-4" style={{ background:T.line2, border:`1px solid ${T.line}` }}>
                      <div className="text-[10px] font-bold uppercase tracking-widest mb-3" style={{ color:T.amber }}>📌 Allowances & Extras</div>
                      <Checkbox label="Includes Overnight Stay ($125/night)" sub="Covers lodging, meals, incidentals" checked={form.overnight} onChange={v=>upd("overnight",v)}/>
                      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mt-3">
                        <Field className="mb-0"><Label>Pole Premium</Label><Input value={form.heightPolePay} onChange={v=>upd("heightPolePay",v)} prefix="$" placeholder="e.g. 50"/></Field>
                        <Field className="mb-0"><Label>Escort Add-Ons</Label><Input value={form.escortAddons} onChange={v=>upd("escortAddons",v)} prefix="$" placeholder="e.g. 75"/></Field>
                      </div>
                      <div className="mt-3">
                        <Label>Fuel Surcharge</Label>
                        <Select value={form.fuelSurcharge} onChange={v=>upd("fuelSurcharge",v)} options={["Included","Not Included","TBD"]} placeholder="Select..."/>
                      </div>
                    </div>

                    <div className="rounded-xl p-3 sm:p-4" style={{ background:T.line2, border:`1px solid ${T.line}` }}>
                      <div className="text-[10px] font-bold uppercase tracking-widest mb-3" style={{ color:T.amber }}>📌 Payment Terms</div>
                      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                        <Field className="mb-0"><Label>Method</Label><Select value={form.paymentMethod} onChange={v=>upd("paymentMethod",v)} options={["Zelle","ACH Bank Transfer","Check","Wire Transfer","Other"]} placeholder="Method"/></Field>
                        <Field className="mb-0"><Label>Terms</Label><Select value={form.paymentTerms} onChange={v=>upd("paymentTerms",v)} options={["Same Day","NET 7","NET 15","NET 30","Upon Completion"]} placeholder="Terms"/></Field>
                      </div>
                    </div>
                  </SectionCard>

                  {/* 5. Dispatch Info */}
                  <SectionCard icon="📞" title="Dispatch Contact Info">
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                      <Field className="mb-0"><Label>Company Name</Label><Input value={form.companyName} onChange={v=>upd("companyName",v)} placeholder="e.g., GreenBridge Energy"/></Field>
                      <Field className="mb-0"><Label>Dispatcher Name</Label><Input value={form.dispatcherName} onChange={v=>upd("dispatcherName",v)} placeholder="e.g., James Miller"/></Field>
                      <Field className="mb-0"><Label>Dispatch Phone</Label><Input type="tel" value={form.dispatchPhone} onChange={v=>upd("dispatchPhone",v)} placeholder="(512) 555-0198"/></Field>
                      <Field className="mb-0"><Label>Dispatch Email</Label><Input type="email" value={form.dispatchEmail} onChange={v=>upd("dispatchEmail",v)} placeholder="dispatch@company.com"/></Field>
                    </div>
                  </SectionCard>

                  {/* 6. Notes */}
                  <SectionCard icon="📝" title="Additional Notes">
                    <Label>Special Instructions or Requirements</Label>
                    <textarea value={form.notes} onChange={e=>upd("notes",e.target.value)}
                      placeholder="e.g., Requires night travel permit, bridge weight limit restrictions, contact driver 2hrs before pickup..." rows={4}
                      style={{ width:"100%", background:T.white, border:`1.5px solid ${T.line}`, borderRadius:10, padding:"12px", color:T.text, fontSize:14, outline:"none", fontFamily:"inherit", resize:"vertical", lineHeight:1.6 }}
                      onFocus={e=>e.target.style.borderColor=T.teal} onBlur={e=>e.target.style.borderColor=T.line}/>
                  </SectionCard>
                </div>

                {/* ── RIGHT SIDEBAR ── */}
                <div className="w-full lg:w-[320px] xl:w-[360px] flex-shrink-0 lg:sticky lg:top-6 space-y-4 sm:space-y-5 pb-6 lg:pb-0 z-10">
                  <LoadPreview form={form} featured={featured}/>

                  {/* Featured listing toggle */}
                  <div className="rounded-2xl p-4 shadow-sm bg-white" style={{ border:`1px solid ${T.line}` }}>
                    <div onClick={()=>setFeatured(p=>!p)} className="flex items-center justify-between cursor-pointer">
                      <div className="flex items-center gap-3">
                        <span className="text-[22px]">⚡</span>
                        <div>
                          <div className="font-bold text-[14px]" style={{ color:T.text }}>Featured Listing</div>
                          <div className="text-[12px]" style={{ color:T.muted }}>Get matched up to 3x faster</div>
                        </div>
                      </div>
                      <div className="w-6 h-6 rounded flex-shrink-0 flex items-center justify-center transition-colors" style={{ border:`2px solid ${featured?T.amber:T.muted}`, background:featured?T.amber:"transparent" }}>
                        {featured && <span className="text-white text-sm font-bold">✓</span>}
                      </div>
                    </div>
                    {featured && (
                      <div className="mt-3 p-3 rounded-lg text-[12px] font-semibold leading-relaxed" style={{ background:T.amberLight, color:T.amber }}>
                        Your load appears at the top of search results and gets priority notifications.
                      </div>
                    )}
                  </div>

                  {/* Checkout / API Trigger */}
                  <div className="rounded-2xl p-5 sm:p-6 shadow-sm bg-white" style={{ border:`1px solid ${T.line}` }}>
                    <div className="flex items-center gap-2 mb-4">
                      <span className="text-lg" style={{ color:T.teal }}>$</span>
                      <span className="font-bold text-[16px]" style={{ color:T.text }}>Order Summary</span>
                    </div>
                    {[
                      { label:"Standard Lead Fee", value:"$15.00" },
                      { label:"Email Notifications", value:"Included", valueColor:T.green },
                      ...(featured ? [{ label:"Featured Listing", value:"+$20.00", valueColor:T.amber }] : []),
                    ].map(r=>(
                      <div key={r.label} className="flex justify-between py-2.5 border-b" style={{ borderColor: T.line2 }}>
                        <span className="text-[13px] sm:text-sm" style={{ color:T.slate }}>{r.label}</span>
                        <span className="text-[13px] sm:text-sm font-bold" style={{ color:r.valueColor||T.text }}>{r.value}</span>
                      </div>
                    ))}
                    <div className="flex justify-between items-center py-4">
                      <span className="font-bold text-[15px]" style={{ color:T.text }}>Total Due Today</span>
                      <span className="font-bold text-[22px]" style={{ color:T.teal }}>${total}.00</span>
                    </div>
                    <div className="text-right text-[11px] mb-4 sm:mb-5" style={{ color:T.muted }}>Charged securely via Stripe</div>

                    <button 
                      onClick={handlePostLoad}
                      disabled={!canSubmit || isSubmitting}
                      className="w-full py-3.5 sm:py-4 rounded-xl border-none font-bold text-[15px] transition-colors"
                      style={{ background:canSubmit?T.teal:"#e2e8f0", color:canSubmit?T.white:T.muted, cursor:canSubmit?"pointer":"not-allowed" }}
                    >
                      {isSubmitting ? "Processing..." : `Pay $${total}.00 & Post →`}
                    </button>

                    {!canSubmit && (
                      <div className="mt-4 text-center text-[12px]" style={{ color:T.muted }}>Fill in Origin, Destination & Date to continue</div>
                    )}
                  </div>
                </div>
                
              </div>
            </div>
          )}
        </main>
        
        {/* BottomNav moved inside the flex-col div so it renders horizontally at the bottom! */}
        <BottomNav activeNav={activeNav} setActiveNav={setActiveNav} />
      </div>

    </div>
  );
}